/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MailboxResponseProvider } from './mailboxResponseProvider';
import type { MailboxResponseStatus } from './mailboxResponseStatus';

/**
 * Read schema. NEVER expose ``nylas_grant_secret_enc`` /
 * ``nylas_imap_secret_enc`` / ``nylas_grant_id``.
 */
export interface MailboxResponse {
  id: string;
  provider: MailboxResponseProvider;
  status: MailboxResponseStatus;
  email_address: string;
  display_name: string;
  is_primary: boolean;
  default_signature_id?: string | null;
  default_signature_name?: string | null;
  unsubscribe_message_html?: string | null;
  today_emails_sent?: number;
  today_bounces?: number;
  last_synced_at?: string | null;
  connected_at: string;
}
